import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

interface DocsViewerProps {
    documentName: string;
}

export const DocsViewer: React.FC<DocsViewerProps> = ({ documentName }) => {
    const [content, setContent] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        let isMounted = true;
        setLoading(true);
        setError(null);

        fetch(`/docs/${documentName}.md?v=${Date.now()}`)
            .then(res => {
                if (!res.ok) throw new Error(res.status === 404 ? 'Documentation file not found.' : 'Failed to load documentation.');
                return res.text();
            })
            .then(text => { if (isMounted) { setContent(text); setLoading(false); } })
            .catch((err: Error) => { if (isMounted) { setError(err.message); setLoading(false); } });

        return () => { isMounted = false; };
    }, [documentName]);

    if (loading) {
        return (
            <div className="docs-loading">
                <div className="docs-loading-spinner" />
                Loading documentation…
            </div>
        );
    }

    if (error) {
        return (
            <div className="docs-error">
                <h3>Error Loading Document</h3>
                <p>{error}</p>
            </div>
        );
    }

    return (
        <div className="docs-article">
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
        </div>
    );
};
